import React from 'react';
import '../../App.css';
import About from '../About';
import Cards from '../Cards';
import Footer from '../Footer';

function Aboutus() {
  return (
    <>
     <About />
      <Cards />
      <Footer />
    </>
  );
}

export default Aboutus;

